import { arrayOrArray, getLabel } from '@apia/util';
import { TProcesses } from './SchedulerTableCell';
import { Box, getVariant } from '@apia/theme';

export const ReserveDetails = ({ processes }: { processes: TProcesses }) => {
  let content = (
    <Box className="no__appoinments">
      <Box as="span">{getLabel('lblNoAppoinments').text} </Box>
    </Box>
  );
  if (processes.length > 0)
    content = (
      <table className="appoinments__details">
        <thead>
          <tr>
            <th>{getLabel('lblId').text}</th>
            <th>{getLabel('flaAtr').text}</th>
          </tr>
        </thead>
        <tbody>
          {processes?.map((c) => {
            const attributes = arrayOrArray(c.attributes.attribute);
            return attributes.map((attr, index) => (
              <tr key={`${c.id}-${index}`}>
                {index === 0 && (
                  <td
                    className="appoinments__details_id"
                    rowSpan={attributes.length}
                  >
                    {c.id}
                  </td>
                )}
                <td className="appoinments__details_attribute" style={{}}>
                  {attr.title}: {attr.value}
                </td>
              </tr>
            ));
          })}
        </tbody>
      </table>
    );
  return (
    <Box {...getVariant('layout.execution.form.fields.scheduler.details')}>
      {content}
    </Box>
  );
};
